// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2EY4R","itemA":"Write_itemA__3puVE","itemB":"Write_itemB__2OpI9","itemC":"Write_itemC__1sA9w","itemD":"Write_itemD__8lIkU"};